module.exports = __webpack_public_path__ + "static/media/todo.6f143605.png";